import { render, staticRenderFns } from "./LaboratorioEtiqueta.vue?vue&type=template&id=2ef6ced8&"
import script from "./LaboratorioEtiqueta.vue?vue&type=script&lang=js&"
export * from "./LaboratorioEtiqueta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports